import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import InsightPage from "@/pages/insight/page";
import ArticleDetailPage from "@/pages/insight/detail/page";
import CategoryPage from "@/pages/category/page";
import FaqPage from "@/pages/faq/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/insight",
    element: <InsightPage />,
  },
  {
    path: "/insight/:id",
    element: <ArticleDetailPage />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;